export const THEMES = [
  { id: "light", label: "Light", statusBarColor: "#f6f0e6", statusBarStyle: "default" },
  { id: "dark", label: "Dark", statusBarColor: "#17191c", statusBarStyle: "black-translucent" },
  { id: "forest", label: "Forest", statusBarColor: "#dfe9df", statusBarStyle: "default" },
  { id: "flowers", label: "Flowers", statusBarColor: "#f4e9e6", statusBarStyle: "default" },
  { id: "mountains", label: "Mountains", statusBarColor: "#e4eef2", statusBarStyle: "default" },
  { id: "ocean", label: "Ocean", statusBarColor: "#dceff0", statusBarStyle: "default" },
  { id: "dinosaurs", label: "Dinosaurs", statusBarColor: "#e8e2d2", statusBarStyle: "default" },
  { id: "space", label: "Space", statusBarColor: "#07111e", statusBarStyle: "black-translucent" },
  { id: "cats", label: "Cats", statusBarColor: "#fff0d2", statusBarStyle: "default" },
  { id: "dogs", label: "Dogs", statusBarColor: "#dff2f1", statusBarStyle: "default" },
  { id: "zoo", label: "Zoo", statusBarColor: "#dff2f1", statusBarStyle: "default" },
  { id: "halloween", label: "Halloween", statusBarColor: "#190f1d", statusBarStyle: "black-translucent" },
  { id: "thanksgiving", label: "Thanksgiving", statusBarColor: "#f2dfbd", statusBarStyle: "default" },
  { id: "christmas", label: "Christmas", statusBarColor: "#e3ece7", statusBarStyle: "default" },
] as const satisfies readonly { id: string; label: string; statusBarColor: string; statusBarStyle: "default" | "black-translucent" }[];

export type ThemeId = (typeof THEMES)[number]["id"];
export type Theme = (typeof THEMES)[number];
export const DEFAULT_THEME: ThemeId = "light";
export const THEME_GROUPS = [
  { label: "Classic", ids: ["light", "dark"] },
  { label: "Scenery", ids: ["forest", "flowers", "mountains", "ocean", "dinosaurs", "space"] },
  { label: "Characters", ids: ["cats", "dogs", "zoo"] },
  { label: "Holidays", ids: ["halloween", "thanksgiving", "christmas"] },
] as const satisfies readonly { label: string; ids: readonly ThemeId[] }[];
